import type { PlatformUserDetailUpdateRequest } from '@/entities/user/api/user.api';

export const VERIFICATION_STATUS_OPTIONS = [
  'NOT_REGISTERED',
  'PENDING',
  'APPROVED',
  'REJECTED',
] as const;

export const FINANCIAL_STATUS_OPTIONS = [
  'NOT_REGISTERED',
  'NOT_VERIFIED',
  'VERIFICATION_FAILED',
  'VERIFIED',
] as const;

export const SALES_APPROVAL_OPTIONS = [
  'TRANSACTION_IMPOSSIBLE',
  'TRANSACTION_POSSIBLE',
  'SETTLEMENT_POSSIBLE',
] as const;

export const verificationStatusLabel = (value?: string): string => {
  switch (value) {
    case 'NOT_REGISTERED':
      return '미등록';
    case 'PENDING':
      return '검토중';
    case 'APPROVED':
      return '승인';
    case 'REJECTED':
      return '반려';
    case 'NOT_VERIFIED':
      return '미인증';
    case 'VERIFICATION_FAILED':
      return '인증 실패';
    case 'VERIFIED':
      return '인증 완료';
    case 'TRANSACTION_IMPOSSIBLE':
      return '거래 신청 불가';
    case 'TRANSACTION_POSSIBLE':
      return '거래 신청 가능';
    case 'SETTLEMENT_POSSIBLE':
      return '정산 가능';
    case 'BUSINESS_TYPE_NOT_ALLOWED':
      return '업종 불가';
    case 'EXPIRED':
      return '만료';
    default:
      return value || '-';
  }
};

/** 레거시 검증 상태 조합으로 영업 승인 상태를 추론한다. */
export const inferSalesApprovalStatus = (
  businessVerificationStatus?: string,
  financialVerificationStatus?: string,
  promoLicenseStatus?: string,
): PlatformUserDetailUpdateRequest['salesApprovalStatus'] => {
  const businessOk =
    businessVerificationStatus === 'PENDING' ||
    businessVerificationStatus === 'APPROVED';
  const financialOk =
    financialVerificationStatus === 'NOT_VERIFIED' ||
    financialVerificationStatus === 'VERIFIED';
  const promoOk =
    promoLicenseStatus === 'PENDING' || promoLicenseStatus === 'APPROVED';

  if (
    businessVerificationStatus === 'APPROVED' &&
    financialVerificationStatus === 'VERIFIED' &&
    promoLicenseStatus === 'APPROVED'
  ) {
    return 'SETTLEMENT_POSSIBLE';
  }

  if (businessOk && financialOk && promoOk) {
    return 'TRANSACTION_POSSIBLE';
  }

  return 'TRANSACTION_IMPOSSIBLE';
};
